import IconButton from '@mui/material/IconButton';
import { alpha, styled } from '@mui/material/styles';

export const FloatingIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.common.white, 0.9),
  boxShadow: theme.customShadows.dropdown,
  '&:hover': {
    backgroundColor: theme.palette.background.paper,
  },
}));
